if (process.env.LOCAL_DEV === "true") {
  require("preact/debug");
}
import "./style/index.scss";
import App from "./components/app";

export default App;
